import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    groundings: [
        {
            id: 'main_grounding',
            area: 0,           // m² - inşaat alanı (çizimden hesaplanır)
            strakeCount: 0,    // adet - topraklama kazığı sayısı (çizimden)
            stripLength: 0,    // metre - şerit boyu (çizimden)
            joingtionCount: 0  // adet - bağlantı sayısı (çizimden)
        }
    ]
};

const groundingSlice = createSlice({
    name: 'grounding',
    initialState,
    reducers: {
        setGroundingData: (state, action) => {
            state.groundings = action.payload;
        },
        addGrounding: (state, action) => {
            state.groundings.push(action.payload);
        },
        updateGroundingById: (state, action) => {
            const { id, changes } = action.payload;
            const groundingIndex = state.groundings.findIndex(grounding => grounding.id === id);
            if (groundingIndex !== -1) {
                state.groundings[groundingIndex] = { ...state.groundings[groundingIndex], ...changes };
            }
        },
        removeGroundingById: (state, action) => {
            const id = action.payload;
            state.groundings = state.groundings.filter(grounding => grounding.id !== id);
        },
        clearAllGroundings: (state) => {
            state.groundings = [];
        }
    }
});

export const {
    setGroundingData,
    addGrounding,
    updateGroundingById,
    removeGroundingById,
    clearAllGroundings
} = groundingSlice.actions;

// Selectors
export const selectGroundings = (state) => state.grounding.groundings;
export const selectGroundingById = (id) => (state) =>
    state.grounding.groundings.find(grounding => grounding.id === id);

export default groundingSlice.reducer;